function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTruckSide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21 19a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm-2.5 1.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0zM11 19a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm-2.5 1.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0z",
    clipRule: "evenodd",
    style: {
      fill: "#00243d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6 10a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v6.5h-1V10H7v10h2v1H7a1 1 0 0 1-1-1V10zm13 11h-6v-1h6v1z",
    clipRule: "evenodd",
    style: {
      fill: "#00243d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M25.5 17h-19v-1h19v1z",
    clipRule: "evenodd",
    style: {
      fill: "#00243d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19 12a1 1 0 0 1 1-1h3.26a1 1 0 0 1 .78.375l1.74 2.176a1 1 0 0 1 .22.624V20a1 1 0 0 1-1 1h-2v-1h2v-5.825L23.26 12H20v4.5h-1V12z",
    clipRule: "evenodd",
    style: {
      fill: "#00243d"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckSide);
export default __webpack_public_path__ + "static/media/truck-side.4915c63e152c21f404f875eeef78c91a.svg";
export { ForwardRef as ReactComponent };